// extracted by mini-css-extract-plugin
module.exports = {"lightColor":"TitleWidget_lightColor__1PkGk","mediumColor":"TitleWidget_mediumColor__vnwPv","darkColor":"TitleWidget_darkColor__1BymY"};